export default __webpack_public_path__ + "static/media/CustomService.847d9eb0.png";